import styled from 'styled-components';
export const InnerContainer = styled.div `
  padding-left: var(--space-900);
  margin-top: var(--space-300);
`;
export const Description = styled.div `
  margin-bottom: var(--space-400);
`;
